import * as React from 'react';
import { compose, Dispatch, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import { LProps, withLocalization } from '../utils/wrappers';
import { State, Modals } from '../redux/state';
import actions from '../redux/actions';
import { Story } from '../userApi';

interface Props {
  isOpen: boolean;
  story?: Story | null;
  spinner?: boolean;
  close: () => void;
  submit: (reason: string) => void;
}

interface LocalState {
  reason: string;
  attempted: boolean;
}

class FlagStoryModal extends React.Component<LProps<Props>, LocalState> {
  public state: LocalState = {
    reason: '',
    attempted: false
  };

  public componentDidUpdate(prevProps: LProps<Props>) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this.setState({ reason: '', attempted: false });
    }
  }

  private submit = () => {
    const reason = this.state.reason.trim();
    this.setState({ attempted: true });
    if (!reason) {
      return;
    }
    this.props.submit(reason);
  }

  public render() {
    const { isOpen, t, close, spinner } = this.props;
    const { reason, attempted } = this.state;
    const invalid = attempted && !reason.trim();
    return (
      <Modal isOpen={isOpen} toggle={close} centered={true}>
        <ModalHeader toggle={close}>{t('Report this post')}</ModalHeader>
        <ModalBody>
          <p className="cc__lighttext">
            {t('Please tell admins why this post should be reviewed. Your report will be sent for moderation.')}
          </p>
          <FormGroup>
            <Label for="cc-flag-reason">{t('Reason')}</Label>
            <Input
              id="cc-flag-reason"
              type="textarea"
              rows={4}
              value={reason}
              invalid={invalid}
              disabled={Boolean(spinner)}
              placeholder={t('Describe the issue…')}
              onChange={(e) => this.setState({ reason: e.target.value })}
            />
            {invalid &&
              <FormFeedback>{t('A reason is required before you can submit.')}</FormFeedback>
            }
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button outline={true} color="secondary" onClick={close} disabled={Boolean(spinner)}>
            {t('Cancel')}
          </Button>
          <Button color="danger" onClick={this.submit} disabled={Boolean(spinner) || !reason.trim()}>
            {t('Submit report')}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = (state: State): Partial<Props> => ({
  isOpen: state.modal === Modals.FlagStory,
  story: state.storyToFlag,
  spinner: state.spinner
});

const mapDispatchToProps = (dispatch: Dispatch): Partial<Props> => bindActionCreators({
  close: actions.closeFlagStoryModal,
  submit: actions.submitStoryFlag
}, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withLocalization('story')
)(FlagStoryModal) as React.ComponentClass<{}>;
